import React from "react";
import { Card } from "../../card";
import { ListTable } from "../../Table/listTable/listTable";
import { studentsListTitle } from "../../../Constants/tableTitles/ListTableTitle/studentsList.titles";
import { transformStudentsListTableData } from "../../../Services/transformer/transformStudentsListTableData";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../../Constants/paths";
import { StudentNavigationHeader } from "../../../Constants/Enums/navigationHeader.enum";
import { StudentListFilter } from "./StudentListFilter";
import { useStudentListFilters } from "../../../hooks/filterHooks/useStudentFilterHooks";

interface IStudentList {
  isStudentsListLoading: boolean;
  studentsList: any;
  studentListNameSpace: string;
}
export const StudentList = ({
  isStudentsListLoading,
  studentsList,
  studentListNameSpace,
}: IStudentList) => {
  // Local state for pagination (not in URL)

  // Use URL filters hook for persistent filter state
  const { setFilter } = useStudentListFilters(studentListNameSpace);

  const navigate = useNavigate();

  const handlePageChange = (newPage: number) => {
    setFilter("page", newPage);
  };

  return (
    <Card cardTitle="Students list">
      <StudentListFilter
        isStudentsListLoading={isStudentsListLoading}
        studetListNameSpace={studentListNameSpace}
      />
      <ListTable
        titles={studentsListTitle}
        data={studentsList?.result || []}
        pagination={{
          onPageChange: handlePageChange,
          totalPage: studentsList?.lastPage || 1,
        }}
        transformFn={transformStudentsListTableData}
        onRowClick={(data: any) => {
          navigate(
            `${Paths.StudentDetails}?section=${StudentNavigationHeader.STUDENT_INFO}&studentId=${data.id}`,
          );
        }}
      />
      <></>
    </Card>
  );
};
